import { useMutation } from '@tanstack/react-query';

import { request } from '~/services/common';

import { ReopenExtraction } from '~/types/reopen';

interface ExtractReopenInput {
  file: File;
  catalogRooms?: Array<{ id: string; name: string }>;
}

export function useExtractReopenDates() {
  return useMutation({
    mutationFn: async ({ file, catalogRooms = [] }: ExtractReopenInput): Promise<ReopenExtraction> => {
      const formData = new FormData();
      formData.append('file', file);
      if (catalogRooms.length > 0) {
        formData.append('roomTypes', JSON.stringify(catalogRooms.map(({ id, name }) => ({ id, name }))));
      }

      return request(`${window.configs.API_HOST}/api/ai-hotel/reopen/extract`, {
        method: 'POST',
        body: formData,
      });
    },
  });
}
